<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center mb-1">
        <div class="d-flex align-items-center">
          <b-avatar
            v-if="productType.data.pticonname"
            size="48"
            :variant="productType.data.pticoncolor || 'light-primary'"
            rounded
            class="mr-2"
          >
            <feather-icon
              :icon="productType.data.pticonname"
              size="24"
            />
          </b-avatar>
          <h2 class="mb-0">{{ productType.data.productTypeName }}</h2>
        </div>
        <div
          v-if="guide.guidePdf && guide.guidePdf !== 0"
          class="d-flex align-items-center"
        >
          <h6 class="d-flex align-items-center mr-2 mb-0">
            <b>Product type documentation</b>
          </h6>
          <b-button
            variant="outline-secondary"
            size="sm"
            class="d-flex align-items-center"
            :href="`${baseURL}downloadguidepdf.cfm?id=${guide.guidePdf}`"
            target="_blank"
            tag="a"
          >
            <b-img
              :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
              height="20"
              style="width: auto;"
            />
            <span class="ml-50 font-weight-bold text-body">Download</span>
          </b-button>
        </div>
      </div>
    </b-card>

    <category-product-data
      v-if="$route.params.ptid && productType.data.productTypeId"
      category="producttype"
      :category-id="String(productType.data.productTypeId)"
      filter-key="producttype"
      :filter-value="String(productType.data.productTypeId)"
    />
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BButton,
  BImg,
} from 'bootstrap-vue'
import CategoryProductData from './CategoryProductData.vue'

export default {
  components: {
    BCard,
    BAvatar,
    BButton,
    BImg,
    CategoryProductData,
  },
  data() {
    return {
      productType: {
        data: {},
        loading: false,
        error: false,
      },
      guide: {
        guidePdf: null,
      },
      baseURL: process.env.VUE_APP_BACKEND_PATH,
    }
  },
  created() {
    this.loadProductType()
    this.loadGuide()
  },
  methods: {
    loadProductType() {
      if (!this.$route.params.ptid) return

      this.productType.loading = true
      this.productType.error = false

      this.$http.get(`public.cfc?method=getProductTypeInfo&producttypeid=${this.$route.params.ptid}`)
        .then(response => {
          this.productType.data = response.data
        })
        .catch(error => {
          this.productType.error = error
        })
        .finally(() => {
          this.productType.loading = false
        })
    },
    loadGuide() {
      if (!this.$route.params.ptid) return

      this.$http.get(`public.cfc?method=getGuideByProductType&producttypeid=${this.$route.params.ptid}`)
        .then(response => {
          this.guide = response.data
        })
        .catch(error => {
          console.error('Error loading guide:', error)
        })
    },
  },
}
</script>
